import React from "react";
import styles from "../LifeFocus/LifeFocus.module.css";
import { useNavigate } from "react-router-dom";
const LifeFocus = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className={styles.containerBox}>
        <div className={styles.lifeimg}>
          <img src="Images/Life-in focus.webp" alt="content man and woman on beach watching the sunrise" loading="lazy" decoding="async" />

          <div className={styles.LifeFocusText}>
            <p>Life,</p>
            <p>in focus</p>
          </div>
        </div>
      </div>
      <div className={styles.partsection}>
        <div
          className={styles.section1}
          onClick={() => navigate("/fusion-technology")}
        >
          <img src="Images/inovation.webp" alt="inovation" loading="lazy" decoding="async" />
          <p>Innovation</p>
        </div>
        <div
          className={styles.section1}
          onClick={() => navigate("/our-company")}
        >
          <img src="Images/leadership.webp" alt="leadership" loading="lazy" decoding="async" />
          <p>Our Company</p>
        </div>
        <div className={styles.section1} onClick={() => navigate("/news-room")}>
          <img src="Images/news.webp" alt="news" loading="lazy" decoding="async" />
          <p>Newsroom</p>
        </div>
      </div>
    </>
  );
};

export default LifeFocus;
